<template>
    <section class="top-wrapper">
        <UserInfo :userInfo="userInfo"></UserInfo>
        <div style="height: calc(var(--gap)*75);overflow:hidden;">
          <levelCard :data="levelData" @click="toRights"></levelCard>
        </div>
        <div class="z"></div>
    </section>
</template>

<script>
import levelCard from './level-card.vue';
import UserInfo from './user-info.vue';


export default {
  name: 'memberTop',
  components: {
    levelCard,
    UserInfo,
  },
  props: {
    userInfo: {
        type: Object,
        default: () => ({
          id: '',
          sex: '女',
          name: '',
          totalPoint: 0,
          availablePoint: 0,
          companyName: ''
        })
    }
  },
  computed: {
    levelData () {
      let { userInfo } = this;
      return {
          level: userInfo.memberLevel || 0,
          name: userInfo.memberLevelName || '',
          isCurrent: true,
          no: userInfo.cardNo || '',
          nextPoint: 0,
          levelBackgroundColor: userInfo.backgroundColor,
          levelFontColor: userInfo.fontColor
      }
    }
  },
  methods: {
    toRights () {
      this.$router.push('/member-rights')
    }
  }
}

</script>

<style lang="scss" scoped>
.top-wrapper {
    min-height: calc(var(--w) * 167);
    overflow: hidden;
    background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/bg1.png');
    background-size: 100% calc(var(--w) * 122);
    background-position: 0 0;
    background-repeat: no-repeat;
    position: relative;
    padding: 0 calc(var(--gap) * 16);
    .z {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: calc(var(--w) * 45);
        background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/bg2.png');
        background-size: 100% calc(var(--w) * 45);
        background-position: 0 0;
        background-repeat: no-repeat;
        pointer-events: none;
    }
}
</style>
